import { useLocation, Navigate } from 'react-router'

const EnsureTrailingSlash = () => {
    const { pathname, search, hash } = useLocation()

    if (pathname === '/') {
        return <Navigate to="/login/" replace />
    }

    if (pathname.endsWith('/')) {
        return null
    }

    return <Navigate to={`${pathname}/${search}${hash}`} replace />
}

export default EnsureTrailingSlash
